"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saleSourceFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
exports.saleSourceFactory = Factory.Sync.makeFactory({
    originator_type: 'membership_definition',
    originator_system: 'membership_service',
    originator_identifier: Factory.each(i => uuid_1.v4()),
    originator_label: 'Mem Definition Test'
});
